import React from "react";


function Society() {
    return(
        <h1>Member </h1>
    )
}

export default Society;